import * as Types from '../../../types.generated';

import { gql } from '@apollo/client';
import { HrisTeamFragmentDoc } from './HrisRoleListContainer.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type HrisRoleSidebarQueryVariables = Types.Exact<{
  id: Types.Scalars['Int']['input'];
}>;


export type HrisRoleSidebarQuery = { __typename?: 'Query', HrisTeam?: { __typename?: 'HrisTeam', manuallyLinked: boolean, activeHrisEmployeeCount: number, id: number, name: string, createdAt: string, hrisIntegration?: { __typename?: 'HrisIntegration', id: string, hrisProvider?: string | null } | null, group?: { __typename?: 'Role', id: number, name: string } | null } | null };


export const HrisRoleSidebarDocument = gql`
    query HrisRoleSidebar($id: Int!) {
  HrisTeam(id: $id) {
    ...HrisTeam
    manuallyLinked
    activeHrisEmployeeCount
    hrisIntegration {
      id
      hrisProvider
    }
  }
}
    ${HrisTeamFragmentDoc}`;

/**
 * __useHrisRoleSidebarQuery__
 *
 * To run a query within a React component, call `useHrisRoleSidebarQuery` and pass it any options that fit your needs.
 * When your component renders, `useHrisRoleSidebarQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useHrisRoleSidebarQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useHrisRoleSidebarQuery(baseOptions: Apollo.QueryHookOptions<HrisRoleSidebarQuery, HrisRoleSidebarQueryVariables> & ({ variables: HrisRoleSidebarQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<HrisRoleSidebarQuery, HrisRoleSidebarQueryVariables>(HrisRoleSidebarDocument, options);
      }
export function useHrisRoleSidebarLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<HrisRoleSidebarQuery, HrisRoleSidebarQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<HrisRoleSidebarQuery, HrisRoleSidebarQueryVariables>(HrisRoleSidebarDocument, options);
        }
export type HrisRoleSidebarQueryHookResult = ReturnType<typeof useHrisRoleSidebarQuery>;
export type HrisRoleSidebarLazyQueryHookResult = ReturnType<typeof useHrisRoleSidebarLazyQuery>;
export type HrisRoleSidebarQueryResult = Apollo.QueryResult<HrisRoleSidebarQuery, HrisRoleSidebarQueryVariables>;